module.exports = __webpack_public_path__ + "img/done.78b8be53.png";